export const MAX_THREAD_IMAGES = 50;

export const countNormalImagesFromHtml = (html: string = ''): number => {
  if (!html) return 0;
  const imgTags = html.match(/<img\b[^>]*>/gi) || [];
  return imgTags.filter(tag => !/data-emoji\s*=\s*["'][^"']+["']/i.test(tag)).length;
};
